export default "__VITE_ASSET__DWdJRWSm__"